import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')

export const PUBLICATIONS_LIST_PAGE_NAME = 'cabinet:publications'
export const PUBLICATION_DETAILS_PAGE_NAME = 'cabinet:publication-details'
export const PUBLICATION_UPDATE_PAGE_NAME = 'cabinet:publication-update'
export const PUBLICATION_CREATE_PAGE_NAME = 'cabinet:publication-create'

// URLs
export const PUBLICATIONS_LIST_PAGE_URL = ''
export const PUBLICATION_DETAILS_PAGE_URL = 'details/:id?/'
export const PUBLICATION_UPDATE_PAGE_URL = 'update/:id?/'
export const PUBLICATION_CREATE_PAGE_URL = 'create/'

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(PUBLICATIONS_LIST_PAGE_URL, list, PUBLICATIONS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'publications',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(PUBLICATION_DETAILS_PAGE_URL, details, PUBLICATION_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'publication-details',
        parent: PUBLICATIONS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(PUBLICATION_UPDATE_PAGE_URL, details, PUBLICATION_UPDATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'publication-update',
        parent: PUBLICATIONS_LIST_PAGE_NAME,
        isUpdate: true,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(PUBLICATION_CREATE_PAGE_URL, details, PUBLICATION_CREATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'publication-create',
        parent: PUBLICATIONS_LIST_PAGE_NAME,
        isNew: true,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
